package com.dignicate.web.theme

import androidx.compose.runtime.staticCompositionLocalOf
import com.dignicate.web.domain.ContentRepository
import com.dignicate.web.domain.Language

enum class ThemeMode { System, Light, Dark }

data class Settings(
    val theme: ThemeMode = ThemeMode.System,
    val language: Language = Language.System,
    // Visual font scaling factor (1.0 = 100%). Used to adjust perceived size per language.
    val fontScale: Float = 1.0f,
    // Visual line height scaling factor (1.0 = 100%). Used to adjust perceived line height per language.
    val lineHeightScale: Float = 1.45f,
    // Animated Header settings (state only). Defaults chosen per spec.
    val headerAnimationEnabled: Boolean = true,
    val headerAnimationSpeed: Float = 0.6f,      // 0.0..1.0
    val headerAnimationIntensity: Float = 0.75f  // 0.0..1.0
)

val LocalSettings = staticCompositionLocalOf { Settings() }
val LocalIsDark   = staticCompositionLocalOf { false }
val LocalLocale   = staticCompositionLocalOf<Language> { Language.En }

/** CompositionLocal for providing ContentRepository to composables. Default to ContentRepositoryImpl for convenience. */
val LocalContentRepository = staticCompositionLocalOf<ContentRepository> { error("provide from app") }

/** 下層から設定を更新するためのコールバック */
val LocalUpdateSettings = staticCompositionLocalOf<(Settings) -> Unit> { { _ -> } }

/** 既存コード互換（以前の LocalDarkMode 名をまだ使っている場合） */
val LocalDarkMode = LocalIsDark
